import {
    SET_TOTAL_UNREAD_ENTRIES
} from '../actions/types';

function totalUnreadEntriesReducer(state = 0, action)
{
    if (action.type === SET_TOTAL_UNREAD_ENTRIES && Number.isInteger(action.payload))
    {
        const totalUnreadEntries = action.payload;
        return totalUnreadEntries;
    }
    
    return state;
}

export default totalUnreadEntriesReducer;


// WEBPACK FOOTER //
// ./redux/reducers/totalUnreadEntriesReducer.js